<template>
  <div>
    <!-- Campo de búsqueda -->
    <b-field label="Buscar">
      <b-input
        v-model="searchQuery"
        placeholder="Buscar..."
        type="search"
        icon-right-clickable
        expanded
        @icon-right-click="searchQuery = ''"
        @input="reloadSearch"
        @keydown.native.enter="loadAsyncData"
      >
      </b-input>

      <b-button @click="loadAsyncData" type="is-primary" class="ml-2"> Buscar </b-button>
    </b-field>

    <!-- Tabla -->
    <b-table
      :data="data"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :loading="loading"
      :per-page="perPage"
      :total="total"
      backend-pagination
      backend-sorting
      paginated
      @page-change="onPageChange"
      @sort="onSort"
      filters-change
    >
      <b-table-column field="nombre" label="Nombre" sortable v-slot="props" width="400px">
        {{ props.row.nombre.toUpperCase() + ' ' + props.row.apellido.toUpperCase() }}
      </b-table-column>
      <b-table-column field="empresa" label="Empresa" sortable v-slot="props" width="400px">
        {{ props.row.empresa.toUpperCase() }}
      </b-table-column>
<!--       <b-table-column field="rfc" label="RFC" sortable v-slot="props">
        {{ props.row.rfc.toUpperCase() }}
      </b-table-column> -->
      <b-table-column field="circulo" label="Circulo" sortable v-slot="props">
        {{ props.row.circulo }}
      </b-table-column>
<!--       <b-table-column field="apellido" label="Telefono" sortable v-slot="props">
        {{ props.row.telefono }}
      </b-table-column>
      <b-table-column field="email" label="Correo" sortable v-slot="props">
        {{ props.row.email }}
      </b-table-column> -->

      <b-table-column field="acciones" label="Acciones" v-slot="props">
        <div class="buttons">
          <b-button @click="openinteractionModal(props.row)" type="is-info" icon-left="handshake" size="is-small" title="Interaccion"></b-button>
        </div>
      </b-table-column>
    </b-table>

    <div class="modal form-associates-modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Socio</h2>
          <button @click="showFormModal = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Form :datavalues="formModalData" @close-form="closeForm"></Form>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>

    <div class="modal form-interaction-modal" :class="{ 'is-active': showFormInteractionModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Interaccion</h2>
          <button @click="showFormInteractionModal = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Interaction :datavalues="formInteractionModalData" @close-form="closeForm"></Interaction>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Form from './form.vue';
import Interaction from './interaction.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    Form,
    Interaction,
  },
  data() {
    return {
      data: [],
      total: 0,
      loading: false,
      sortField: 'nombre',
      sortOrder: 'ASC',
      defaultSortOrder: 'ASC',
      page: 1,
      perPage: 20,
      searchQuery: '',
      showFormModal: false,
      formModalData: {},
      showFormInteractionModal: false,
      formInteractionModalData: {},
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.loadAsyncData();
  },
  computed: {
    ...mapState({
      associates: (state) => state.associates.list,
      pagination: (state) => state.associates.pagination,
      reload: (state) => state.associates.reloadList,
      partner: (state) => state.auth.partner,
    }),
  },
  watch: {
    async reload(newValue) {
      if (newValue) {
        await this.loadAsyncData();
      }
    },
    async partner() {
      await this.loadAsyncData();
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'associates/fetchList',
      remove: 'associates/remove',
    }),
    async loadAsyncData() {
      if (!this.partner.id) {
        return;
      }

      this.loading = true;

      const params = {
        page: this.page,
        size: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        search: this.searchQuery.toLowerCase(),
        socio_id: this.partner.id, // necesito que primero carge la informacion de partner para obter el id 
      };

      await this.fetchList(params);

      this.data = this.associates;
      this.total = this.pagination.total;

      this.loading = false;
      this.$store.commit('associates/SET_DATA', { key: 'reloadList', data: false });
    },
    async onPageChange(page) {
      this.page = page;
      await this.loadAsyncData();
    },
    async onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      await this.loadAsyncData();
    },
    async reloadSearch() {
      if (this.searchQuery.length == 0) {
        await this.loadAsyncData();
      }
    },
    openModal(data) {
      this.showFormModal = true;
      this.formModalData = data;
    },
    openinteractionModal(data) {
      this.showFormInteractionModal = true;
      this.formInteractionModalData = data;
    },
    closeForm() {
      this.showFormModal = false;
      this.showFormInteractionModal = false;
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás recuperar este registro después de eliminarlo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        const response = await this.remove(id);

        Swal.fire({
          icon: response.status ? 'success' : 'error',
          title: response.message,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        await this.loadAsyncData();
      }
    },
  },
};
</script>
